export const ELEVIO_LANGUAGE_MAP = {
  de: 'de',
  en: 'en',
  es: 'en',
  fr: 'en',
  pt: 'en',
};
